import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { MemberStatusTypes } from '../Types';

const machine = Machines.onMemberStatus.machine;

export const getMemberStatus = (
  params: MemberStatusTypes.MemberStatusServiceRequestType,
): Promise<MemberStatusTypes.IMemberStatusServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { getMemberStatus };
